export var getEntriesByName = function getEntriesByName(mark) {
  var performance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance;

  if (!performance || typeof performance.getEntriesByName !== 'function') {
    return undefined;
  }

  return performance.getEntriesByName(mark);
};
export var mark = function mark(performanceMark) {
  var performance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance;

  if (!performance || typeof performance.mark !== 'function') {
    return;
  }

  performance.mark(performanceMark);
};
export var clearMarks = function clearMarks(performanceMark) {
  var performance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance;

  if (!performance || typeof performance.clearMarks !== 'function') {
    return;
  }

  performance.clearMarks(performanceMark);
};
export var measure = function measure(measurementName, startMark, endMark) {
  var performance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.performance;

  if (!performance || typeof performance.measure !== 'function') {
    return;
  }

  performance.measure(measurementName, startMark, endMark);
};
//# sourceMappingURL=performance.js.map